"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetWishlistOrderCommand = void 0;
class SetWishlistOrderCommand {
    constructor(userId, targetStudyId, position, expectedState, isLocal) {
        this.userId = userId;
        this.targetStudyId = targetStudyId;
        this.position = position;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.SetWishlistOrderCommand = SetWishlistOrderCommand;
